import React, { useState, useEffect } from 'react'
import { Button, Card, Icon, Spin, Select, DatePicker, message, Tooltip } from 'antd'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import ProductionStatisticsBySewingPartnerTable from './table/ProductionStatisticsBySewingPartnerTable'
import { listPartner } from '../../../services/api/3dApi'
import queryString from 'query-string'
import { statisticProductionQuantityBySewingPartner } from '../../../services/api/3dApi'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import FilterMaterials from '../../batchesV3/components/filters/FilterMaterials'
import { getListMaterial } from '../../../services/api/3dApi'
import SelectFilterOptions from '../../shared/SelectFilterOptions'
import SearchField from '../../home/components/filters/SearchField'
import { TAGS } from '../../batchesV3/components/filters/listOptions.json'

const { RangePicker } = DatePicker

const MAX_MONTHS = 3
const DEFAULT_RANGE_DAYS = 7 // 7 ngày gần nhất (today và 6 ngày trước)

function ProductionStatisticsBySewingPartnerPage() {
    const [loading, setLoading] = useState(false)
    const [statisticData, setStatisticData] = useState([])
    const [error, setError] = useState('')
    const [listSewingPartner, setListSewingPartner] = useState([])
    const [sewingPartner, setSewingPartner] = useState([])
    // Default time: last 7 days (today and 6 days before)
    const [time, setTime] = useState([moment().subtract(DEFAULT_RANGE_DAYS - 1, 'days'), moment()])

    // track partial calendar selection to properly disable dates
    const [calendarRange, setCalendarRange] = useState([null, null])
    const [productTypes, setProductTypes] = useState([])
    const [materials, setMaterials] = useState([])
    const [listMaterials, setListMaterials] = useState([])
    const [listPrintPartner, setListPrintPartner] = useState([])
    const [printPartner, setPrintPartner] = useState([])
    const [userCreate, setUserCreate] = useState('')
    const [tags, setTags] = useState([])
    const history = useHistory()

    const fetchListSewingPartner = async () => {
        try {
            const payload = {
                limit: 10000,
                page: 1,
                hidden: false,
                type: 'sewing_partner'
            }
            const query = queryString.stringify(payload)

            const { data: response } = await listPartner(query)
            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            const { partners = [] } = data || {}
            const newListSewingPartner =
                Array.isArray(partners) && partners.length > 0
                    ? partners.map((i) => ({ label: i.name, value: i._id }))
                    : []
            setListSewingPartner(newListSewingPartner)
        } catch (error) {
            console.log(error.message)
        }
    }

    const fetchListPrintPartner = async () => {
        try {
            const payload = {
                limit: 10000,
                page: 1,
                hidden: false,
                type: 'print_partner'
            }
            const query = queryString.stringify(payload)
            const { data: response } = await listPartner(query)
            const { data, success, error } = response
            if (!success) throw new Error(error)
            const { partners = [] } = data || {}
            const newListPrintPartner =
                Array.isArray(partners) && partners.length > 0
                    ? partners.map((i) => ({ label: i.name, value: i._id }))
                    : []
            setListPrintPartner(newListPrintPartner)
        } catch (error) {
            console.log(error.message)
        }
    }

    const fetchListMaterials = async () => {
        try {

            const { data: res } = await getListMaterial({ limit: 10000 })
            const { data, success, message: mess } = res || {}
            if (!success) {
                throw new Error(mess)
            }
            setListMaterials(data.data || [])
        } catch (error) {
            message.error(error.message)
        }
    }

    const fetchStatisticData = async () => {
        setLoading(true)
        setError('')
        try {
            const [from, to] = time
            const payload = {}
            if (Array.isArray(sewingPartner) && sewingPartner.length > 0) {
                payload.partner = sewingPartner.join(',')
            }
            if (Array.isArray(printPartner) && printPartner.length > 0) {
                payload.print_partner = printPartner
            }
            if (userCreate && userCreate.trim()) {
                payload.user_create = userCreate.trim()
            }
            if (Array.isArray(tags) && tags.length > 0) {
                payload.tags = tags
            }
            if (Array.isArray(productTypes) && productTypes.length > 0) payload.product_types = productTypes
            let arrMaterial = []
            if (Array.isArray(materials) && materials.length) {
                materials.forEach(item => {
                    const material = listMaterials.find(i => i.name === item) || {}
                    const code = !!material.code ? material.code : ''
                    arrMaterial.push(`${code} - ${item}`)
                })

                arrMaterial.push(...materials)
            } else {
                !!materials && materials.length && arrMaterial.push(materials)
            }
            if (Array.isArray(arrMaterial) && arrMaterial.length > 0) payload.materials = arrMaterial
            if (from && to) {
                payload.from = from.format('YYYY-MM-DD')
                payload.to = to.format('YYYY-MM-DD')
            } else {
                setStatisticData([])
                setLoading(false)
                return
            }

            const { data: response } = await statisticProductionQuantityBySewingPartner(payload)
            const { success, data = {}, message: mess, error: err } = response || {}

            if (!success) {
                throw new Error(mess || err)
            }

            // Nếu client gửi nhiều partner: sewingPartner là mảng id
            let newDataArr = []
            if (Array.isArray(sewingPartner) && sewingPartner.length > 0) {
                // map theo từng id đã chọn (bỏ những id không có trong data)
                newDataArr = sewingPartner.map((id) => data[id]).filter(Boolean)
            } else {
                // không filter -> lấy tất cả
                newDataArr = Object.values(data)
            }

            setStatisticData(newDataArr)
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }


    const handleChangeSelect = (field, value) => {
        if (field === 'sewingPartner') {
            setSewingPartner(Array.isArray(value) ? value : value ? [value] : [])
        }
        if (field === 'printPartner') {
            setPrintPartner(Array.isArray(value) ? value : value ? [value] : [])
        }
        if (field === 'tags') {
            setTags(Array.isArray(value) ? value : value ? [value] : [])
        }
        if (field === 'time') {
            if (!value || !Array.isArray(value) || value.length !== 2) {
                setTime([null, null])
                return
            }
            const [from, to] = value
            if (from && to) {
                const monthsDiff = Math.abs(to.diff(from, 'months', true))
                if (monthsDiff > MAX_MONTHS) {
                    message.error(`Vui lòng chọn khoảng thời gian tối đa ${MAX_MONTHS} tháng.`)
                    return
                }
            }
            setTime(value)
        }
    }

    const handleCalendarChange = (vals) => {
        setCalendarRange(Array.isArray(vals) ? vals : [null, null])
    }

    const disabledDate = (current) => {
        if (!current) return false
        const [calStart, calEnd] = calendarRange || []
        const [stateStart, stateEnd] = time || []

        // if user is picking end date (start selected in calendar)
        if (calStart && !calEnd) {
            const monthsDiff = Math.abs(current.diff(calStart, 'months', true))
            return monthsDiff > MAX_MONTHS
        }
        // if user is picking start date (end selected in calendar)
        if (!calStart && calEnd) {
            const monthsDiff = Math.abs(calEnd.diff(current, 'months', true))
            return monthsDiff > MAX_MONTHS
        }

        // fallback: if time state has only start or only end (rare because we control time), use that
        if (stateStart && !stateEnd) {
            const monthsDiff = Math.abs(current.diff(stateStart, 'months', true))
            return monthsDiff > MAX_MONTHS
        }
        if (!stateStart && stateEnd) {
            const monthsDiff = Math.abs(stateEnd.diff(current, 'months', true))
            return monthsDiff > MAX_MONTHS
        }

        return false
    }

    const formatRate = (numerator, denominator) => {
        const num = Number(numerator) || 0
        const den = Number(denominator) || 0

        if (den === 0) return '0%'

        const value = (num / den) * 100

        if (!Number.isFinite(value)) return '0%'

        return Number.isInteger(value) ? `${value}%` : `${value.toFixed(2)}%`
    }

    // CSV export
    const exportCSV = () => {
        if (!statisticData || statisticData.length === 0) {
            message.info('Không có dữ liệu để xuất.')
            return
        }
        const filename = `production_by_partner_${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`

        const preferredOrder = [
            'Partner may',
            'Tổng số lượng đẩy',
            'Tổng số lượng tồn kho',
            'Tổng số lượng đã may',
            'Tổng số lượng đúng hạn',
            'Tổng số lượng quá hạn',
            'Tỉ lệ quá hạn (%)',
            'error',
            'Tỉ lệ lỗi (%)'
        ]

        const rows = statisticData.map(item => {
            const total = Number(item.total || 0)
            const late = Number(item.late || 0)
            const errorCount = Number(item.error || 0)
            const inStock = item.inProgress != null ? item.inProgress : ''
            const received = item.received != null ? item.received : ''
            const onTime = item.onTime != null ? item.onTime : ''
            const partnerName = item.partner != null ? item.partner : ''

            const fmt = (v) => {
                return Number.isFinite(v) ? Number(v).toFixed(2) + '%' : '0.00%'
            }

            return [
                partnerName,
                total,
                inStock,
                received,
                onTime,
                late,
                formatRate(late, total),
                errorCount,
                formatRate(errorCount, total)
            ]
        })

        const escapeCell = (cell) => {
            const s = String(cell ?? '')
            const needQuote = /[",\n\r]/.test(s)
            const escaped = s.replaceAll(/"/g, '""')
            return needQuote ? `"${escaped}"` : escaped
        }

        const csvBody = [preferredOrder, ...rows].map(row => row.map(escapeCell).join(',')).join('\n')
        const csvContentWithBOM = '\uFEFF' + csvBody

        const blob = new Blob([csvContentWithBOM], { type: 'text/csv;charset=utf-8;' })

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename)
        } else {
            const link = document.createElement('a')
            const url = URL.createObjectURL(blob)
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
            message.success(`Đã xuất file ${filename}`)
        }
    }

    useEffect(() => {
        fetchListSewingPartner()
        fetchListMaterials()
        fetchListPrintPartner()
    }, [])

    useEffect(() => {
        fetchStatisticData()
    }, [sewingPartner, time, productTypes, materials, printPartner, userCreate, tags])

    return (
        <div className="ProductionStatisticsBySewingPartnerPage px-3 pt-0 pb-3">
            <Card
                className="m-3 ProductionProgress"
                title={
                    <span className='d-flex align-items-center justify-content-between'>
                        <span className='text-uppercase'>Thống kê sản xuất theo partner may</span>
                        <div className='d-flex align-items-center' style={{ gap: 12 }}>
                            <Button
                                type='link'
                                onClick={() => history.push('/sewing-productivity-statistics')}
                                style={{ fontSize: 14, fontWeight: 500, textDecoration: 'underline', padding: 0 }}
                            >
                                Thống kê năng suất may
                            </Button>
                            <Button
                                type='primary'
                                icon='export'
                                className='ButtonCustom'
                                onClick={exportCSV}
                            >
                                Export
                            </Button>
                        </div>
                    </span>
                }
                extra={<Icon type="pie-chart" />}
            >
                <div className="filters row d-flex flex-wrap align-items-start mb-5 mx-0" style={{ gap: 10 }}>
                    <div className="filterSewingPartner d-flex align-items-center">
                        <span className="filterTitle">Partner</span>
                        <div className="filterItem d-flex align-items-center mx-2">
                            <Select
                                value={sewingPartner || []}
                                mode='multiple'
                                placeholder='--Select partner--'
                                style={{ width: 200 }}
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.props?.children || '').toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => handleChangeSelect('sewingPartner', e)}
                                optionFilterProp="children"
                            >
                                {Array.isArray(listSewingPartner) && listSewingPartner.length > 0 && listSewingPartner.map((i, idx) => (
                                    <Select.Option key={`sewingPartner_${i.value}_${idx}`} value={i.value}>{i.label}</Select.Option>
                                ))
                                }
                            </Select>
                        </div>
                    </div>
                    <div className="filterDateTime d-flex align-items-center">
                        <span className="filterTitle">Time</span>
                        <div className="filterItem d-flex align-items-center mx-2">
                            <RangePicker
                                value={time}
                                format={'DD/MM/YYYY'}
                                onChange={(e) => handleChangeSelect('time', e)}
                                onCalendarChange={(vals) => handleCalendarChange(vals)}
                                allowClear
                                disabledDate={disabledDate}
                                ranges={{
                                    'Today': [moment(), moment()],
                                    'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                }}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-start col-12 col-xl-3 px-0">
                        <span className="filterTitle" style={{ paddingTop: 5.5 }}>SKU</span>
                        <div className="filterItem mx-2 w-100" style={{ minWidth: 360, maxWidth: 'calc(100%-(25.19px + 16px))' }}>
                            <FilterProductType
                                productTypes={productTypes || []}
                                onChangeProductType={(e) => { setProductTypes(e) }}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-start col-12 col-xl-3 px-0">
                        <span className="filterTitle" style={{ paddingTop: 5.5 }} >Nguyên vật liệu</span>
                        <div className="filterItem mx-2" style={{ width: 329 }}>
                            <FilterMaterials
                                listOptions={listMaterials}
                                materials={materials}
                                onChangeMaterials={(e) => { setMaterials(e) }}
                            />
                        </div>
                    </div>
                    <div className="filterPrintPartner d-flex align-items-center">
                        <span className="filterTitle">Đối tác in ép</span>
                        <div className="filterItem d-flex align-items-center mx-2">
                            <Select
                                value={printPartner || []}
                                mode='multiple'
                                placeholder='--Chọn đối tác in ép--'
                                style={{ width: 200 }}
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.props?.children || '').toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => handleChangeSelect('printPartner', e)}
                                optionFilterProp="children"
                            >
                                {Array.isArray(listPrintPartner) && listPrintPartner.map((i, idx) => (
                                    <Select.Option key={`printPartner_${i.value}_${idx}`} value={i.value}>{i.label}</Select.Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <div className="filterUserCreate d-flex align-items-center">
                        <span className="filterTitle">Người tạo lô</span>
                        <div className="filterItem d-flex align-items-center mx-2">
                            <SearchField
                                field='user_create'
                                placeholder='Tìm kiếm người tạo...'
                                onChangeInput={(field, value) => setUserCreate(value)}
                            />
                        </div>
                    </div>
                    <div className="filterTags d-flex align-items-center">
                        <span className="filterTitle">Tags</span>
                        <div className="filterItem d-flex align-items-center mx-2">
                            <SelectFilterOptions
                                value={tags}
                                mode="tags"
                                listOptions={TAGS}
                                style={{ width: 200 }}
                                field="tags"
                                placeholder='Chọn tag'
                                allowClear
                                handleChange={handleChangeSelect}
                            />
                        </div>
                    </div>
                    <div className="refreshPage">
                        <Tooltip title="Refresh">
                            <Button className='refreshBtn' onClick={() => fetchStatisticData()}>
                                <i className='fa fa-refresh cursor-pointer' style={{ fontSize: 20 }} />
                            </Button>
                        </Tooltip>
                    </div>
                </div>
                <Spin tip="Loading..." spinning={loading}>
                    <ProductionStatisticsBySewingPartnerTable
                        statisticData={statisticData}
                        formatRate={formatRate}
                    />
                    {
                        error && (
                            <div className="text-danger font-18">{error}</div>
                        )
                    }
                </Spin>
            </Card>
        </div>
    )
}

export default ProductionStatisticsBySewingPartnerPage